import { useQuery } from '@tanstack/react-query';
import http from '../../../utils/http';


export function useGetMedicalRecord(dependentId?: string) {
  const query = dependentId
    ? `medical-records/patient/latest?dependentId=${dependentId}`
    : `medical-records/patient/latest`;
  const { data, refetch, ...rest } = useQuery({
    queryKey: ['patient medical record', dependentId ?? ''],
    queryFn: async () => {
      const response = await http.get(query);
      return response.data;
    },
    enabled: !!dependentId || dependentId === undefined, // Enable the query if dependentId is present or undefined
  });
  return {
    medicalRecords: data,
    refetchMedicalRecords: refetch,
    ...rest,
  }
}